import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getInvestorApiUrl, getUserApiUrl } from "../../utils/config";
import { UserData } from "../types";
import { ApiRequestParams, handleFetchApi } from "../../utils/api";
import { AxiosResponse } from "axios";

// Define the types for the state objects
export interface UserProfile {
  id: string | number;
  firstName: string;
  lastName: string;
  city: string;
  state: string;
  email: string;
  mobilePhone: string;
  streetAddress1: string;
  zipCode: string;
  streetAddress2: string;
}
export interface statusResponse {
  statusCode: number,
  message: string,
  data: any
}

interface EmailStatusResponse {
  status: string;
  message: string;
  data?: any;
}

// Add interface for the error
interface ApiError {
  response?: {
    data: string;
  };
  message: string;
}

interface BusinessUserData {
  Email: string | null;
  Phone: string | null;
  DeliveryLine: string | null;
  City: string | null;
  State: string | null;
  Country: string;
  ZipCode: string | null;
  IdNumber: string | null;
  UserType: string | null;
  BusinessName: string | null;
  BusinessTypeId: number;
  BusinessCategoriesId: number;
  OperatingAs: string | null;
  BusinessWebsite: string | null;
  parentInvestorId?: any;
  profileName?: any;
  SignupEmail?: any;
  RegistrationDate?: any;
  RegistrationState?: any;
}

interface OfficerData {
  firstName: string;
  lastName: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  dateOfBirth: string;
  socialSecurityNumber: string;
  email: string;
  phone: string;
  documentState?: string,
  documentCountry?: string,
  documentId?: string,
  documentType?: string,
  percentOwnership?: any;
  selectedExistingUser?: any;
  selectedExistingBeneficialOwner?: any;
  
}

interface State {
  userData: UserData;
  loginUserDetails: any;
  loginuserDetailsResponse: any;
  bussinessUserdata: BusinessUserData;
  Administration: OfficerData;
  controllingOfficer: OfficerData;
  benificialsOfficers: OfficerData[];
  loading: boolean;
  loadingUpdate: boolean;
  loadingProfile: boolean;
  error: any;
  responseData: any | null;
  investorId: string | number;
  businessId: string;
  adminInvestorId: string;
  controllingId: string;
  beneficialId: string;
  isBenificial: boolean;
  benificialPercentage: any;
  benificislaIds: string[];
  isBusiness: boolean;
  isIndividual: boolean;
  loginUserId?: any
  checkEmail: {
    business: string;
    Administrator: string;
    "Controlling Officer": string;
    "Beneficial Owner": string[];
  };
  tearmsIpdate: string | null;
  userResponse?: any;
  userProfile: UserProfile;
  loginInvestorId: any;
  businessInvestorAdminstration?: any;
  businessInvestorControllingID?: any;
  businessInvestorBeneficialID?: any;
  emailStatus: EmailStatusResponse | null;
  radioControllingState: boolean;
  isBenificialneededState: "yes" | "no";
  isThisBenificialOwnerState: "yes" | "no" | null;
  isThisBenificialOwnerCoState: "yes" | "no" | null;
  kycInvestorErrorState: unknown;
  isUpdateFlow: boolean;
  isBusinessUpdate: boolean;
  isBusinessRegUpdate: boolean;
}

export const initialState: State = {
  businessInvestorAdminstration: null,
  businessInvestorControllingID: null,
  businessInvestorBeneficialID: [],
  loginUserDetails: {},
  loginInvestorId: "",
  loginuserDetailsResponse: "",
  userData: {
    firstName: "",
    lastName: "",
    socialSecurityNumber: "",
    birthDate: "",
    address: "",
    city: "",
    state: "",
    country: "US",
    userName: "",
    email: "",
    phone: "",
    deliveryLine: "",
    IsExisting: "",
    zipCode: "",
    deliveryLine2: "",
    userType: "",
    lastVerifiedOn: "",
    profileName: "",
    BusinessAccounts: [],
    IsDefault: false,
    IsDeleted: false,
    SignupEmail: "",
    AccountStatus: null,
    UserId: null,
    purchaseProfile: [],
    BusinessDetailsResponse: [],
  },
  loginUserId: "",
  bussinessUserdata: {
    parentInvestorId: 0,
    profileName: "",
    Email: null,
    Phone: null,
    DeliveryLine: null,
    City: null,
    State: null,
    Country: "US",
    ZipCode: null,
    IdNumber: null,
    UserType: null,
    BusinessName: null,
    BusinessTypeId: 0,
    BusinessCategoriesId: 0,
    OperatingAs: null,
    BusinessWebsite: null,
    SignupEmail: null,
  },
  Administration: {
    firstName: "",
    lastName: "",
    address: "",
    city: "",
    state: "",
    zipCode: "",
    dateOfBirth: "",
    socialSecurityNumber: "",
    email: "",
    phone: "",
  },
  controllingOfficer: {
    firstName: "",
    lastName: "",
    address: "",
    city: "",
    state: "",
    zipCode: "",
    dateOfBirth: "",
    socialSecurityNumber: "",
    email: "",
    phone: "",
    documentState: "",
    documentCountry: "",
    documentId: "",
    documentType: "",
    selectedExistingUser: ""
  },
  benificialsOfficers: [
    {
      firstName: "",
      lastName: "",
      address: "",
      city: "",
      state: "",
      zipCode: "",
      dateOfBirth: "",
      socialSecurityNumber: "",
      email: "",
      phone: "",
      percentOwnership: "",
      selectedExistingBeneficialOwner: "",
      
    },
  ],
  loading: false,
  loadingUpdate: false,
  loadingProfile: false,
  error: "",
  responseData: null,
  investorId: "",
  businessId: "",
  adminInvestorId: "",
  controllingId: "",
  beneficialId: "",
  isBenificial: false,
  benificialPercentage: 0,
  benificislaIds: [],
  isBusiness: false,
  isIndividual: false,
  checkEmail: {
    business: "",
    Administrator: "",
    "Controlling Officer": "",
    "Beneficial Owner": [],
  },
  tearmsIpdate: null,
  userResponse: null,
  userProfile: {
    id: "",
    firstName: "",
    lastName: "",
    city: "",
    state: "",
    email: "",
    mobilePhone: "",
    streetAddress1: "",
    zipCode: "",
    streetAddress2: "",
  },
  emailStatus: null,
  radioControllingState: false,
  isBenificialneededState: "no",
  isThisBenificialOwnerCoState: null,
  isThisBenificialOwnerState: null,
  kycInvestorErrorState: {
    Administrator: {},
    "Controlling Officer": {},
    "Beneficial Owner": [{}],
  },
  isUpdateFlow: false,
  isBusinessUpdate: false,
  isBusinessRegUpdate: false

};

// The registerUser action, updated to modify userData based on userType
export const registerUser = createAsyncThunk<
  { apiData: any; userData: any; type: string },
  { type: string;[key: string]: any },
  { rejectValue: string }
>("user/postUser", async (userData, thunkApi) => {
  const { type, subCategory, ...userDataWithoutType } = userData;
  try {
    const params: ApiRequestParams = {
      baseUrl: getInvestorApiUrl(),
      method: "POST",
      payload: userDataWithoutType,
      endpoint: "registration",
    };
    const response = await handleFetchApi(params);
    return { apiData: response.data, userData, type: type };
  } catch (error: any) {
    return thunkApi.rejectWithValue(
      error.response?.data || "An error occurred"
    );
  }
});

export const editandDeleteProfile = createAsyncThunk(
  "user/editandDeleteProfile",
  async (payload: any, thunkApi) => {
    try {
      const params: ApiRequestParams = {
        baseUrl: getInvestorApiUrl(),
        method: "POST",
        payload,
        endpoint: "investor/purchaseprofile",
      };
      const response = await handleFetchApi(params);
      return { apiData: response.data, payload };
    } catch (error: any) {
      return thunkApi.rejectWithValue(
        error.response?.data || "An error occurred"
      );
    }
  }
);

export const getEmailStatus = createAsyncThunk<EmailStatusResponse, string>(
  "user/getEmailStatus",
  async (email: string, { rejectWithValue }) => {
    try {
      if (!email) {
        throw new Error('Email is required');
      }

      const params: ApiRequestParams = {
        baseUrl: getInvestorApiUrl(),
        endpoint: `registration/check-business-email-exists?email=${encodeURIComponent(email)}&userType=business`,
      };

      const response = await handleFetchApi(params);
      return response.data.body;
    } catch (error) {
      const apiError = error as ApiError;
      return rejectWithValue(
        apiError.response?.data || apiError.message || "Failed to check email status"
      );
    }
  }
);
export const postInvestorLoginTime = createAsyncThunk<
  null, // Return type
  void, // No arguments
  { rejectValue: string } // Error type
>(
  "user/postInvestorLoginTime",
  async (_, { rejectWithValue }) => {
    try {
      const params: ApiRequestParams = {
        baseUrl: getUserApiUrl(),
        endpoint: `auth/investor-login`,
        method: "POST", // assuming it's a POST
      };

      const response = await handleFetchApi(params);
      return null;
    } catch (error) {
      console.log(error)
      const apiError = error as ApiError;
      return rejectWithValue(
        apiError.response?.data || apiError.message || "Failed to log investor login time"
      );
    }
  }
)


export const getRegisterdInvestors = createAsyncThunk<any, string>(
  "user/getInvestor",
  async (email: string, thunkApi) => {

    try {
      if (email) {

        const params: ApiRequestParams = {
          baseUrl: getInvestorApiUrl(),
          endpoint: `registration/investors?email=${email}`,
        };
        const response = await handleFetchApi(params);
        if (response.data.statusCode === 200) {
          return {
            error: response?.data?.body,
            response: response?.data?.body,
            investorId: response?.data?.body?.InvestorId,
            isEmailRegistered: true,
          };
        } else {
          return {
            response: null,
            investorId: null,
            isEmailRegistered: false,
            error: response.data.body,
          };
        }
      }
    } catch (error: any) {
      return thunkApi.rejectWithValue(
        error.response?.data || "An error occurred"
      );
    }
  }
);
export const getInvestorProfile = createAsyncThunk<any, number | string>(
  "user/getInvestorProfile",
  async (id, thunkApi) => {
    try {
      if (id) {
        const params: ApiRequestParams = {
          baseUrl: getInvestorApiUrl(),
          endpoint: `BidderProfile?investorId=${id}`,
        };
        const response = await handleFetchApi(params);
        if (response.status === 200) return response.data;
      }
    } catch (error: any) {
      return thunkApi.rejectWithValue(
        error.response?.data || "An error occurred"
      );
    }
  }
);
export const updateInvestorProfile = createAsyncThunk<any, UserProfile>(
  "user/postInvestorProfile",
  async (payload, thunkApi) => {
    try {
      const params: ApiRequestParams = {
        baseUrl: getInvestorApiUrl(),
        endpoint: `BidderProfile`,
        payload,
        method: "PUT",
      };
      const response = await handleFetchApi(params);
      if (response.status === 200) {
        return response.data;
      }
    } catch (error: any) {
      return thunkApi.rejectWithValue(
        error.response?.data || "An error occurred"
      );
    }
  }
);
export const fetchInvestorInvitionStatus = createAsyncThunk<AxiosResponse<statusResponse, any>, { email: string }>(
  "user/fetchInvestorStatus",
  async (payload, thunkApi) => {
    try {
      const params: ApiRequestParams = {
        baseUrl: getUserApiUrl(),
        endpoint: `users/signup/validate-email`,
        payload,
        method: "POST",
      };
      const response = await handleFetchApi(params);
      return response
    } catch (error: any) {
      // Return the error with rejectWithValue
      // Ensure we are passing the status code and error message correctly
      return thunkApi.rejectWithValue({
        message: error.message,
        statusCode: error?.response?.status || 500, // Default to 500 if status is not available
        response: error.response
      });

    }
  }
);

export const getTermsUpdate = createAsyncThunk<
  any,
  any,
  { rejectValue: string }
>("user/termsUpdate", async (payload, thunkApi) => {
  try {
    const params: ApiRequestParams = {
      baseUrl: getInvestorApiUrl(),
      method: "PUT",
      endpoint: `registration/investors/terms`,
      payload,
    };
    const response = await handleFetchApi(params);
    return {
      ok: response.data.statusCode === 200,
      response: response,
      message: response?.data?.body,
    };
  } catch (error: any) {
    return thunkApi.rejectWithValue(
      error.response?.data || "An error occurred"
    );
  }
});
export const postInvestorUser = createAsyncThunk<
  any,
  string,
  { rejectValue: string }
>("user/postInvestorUser", async (payload, thunkApi) => {
  try {
    const params: ApiRequestParams = {
      endpoint: "users/investor",
      method: "POST",
      payload,
    };
    const response = await handleFetchApi(params);
    return response;
  } catch (error: any) {
    return thunkApi.rejectWithValue(
      error.response?.data || "An error occurred"
    );
  }
});

export const updateProfileName = createAsyncThunk(
  "user/updateProfileName",
  async (payload: { investorId: any; profileName: string }) => {
    const params: ApiRequestParams = {
      endpoint: "/investor/purchase-profilename",
      method: "POST",
      baseUrl: getInvestorApiUrl(),
      payload,
    };
    const response = await handleFetchApi(params);
    return response.data;
  }
);

// New thunk to call /registration/existing-user/{investorId}/{user_type}
export const getExistingUser = createAsyncThunk<any, { investorId: string | number; user_type: string }>(
  "user/getExistingUser",
  async ({ investorId, user_type }, thunkApi) => {
    console.log(investorId, user_type, 'investorId, user_type')
    try {
      const params: ApiRequestParams = {
        baseUrl: getInvestorApiUrl(),
        endpoint: `registration/existing-user/${investorId}`,
      };
      const response = await handleFetchApi(params);
      console.log(response, "data in redux")
      return response.data;
    } catch (error: any) {
      return thunkApi.rejectWithValue(
        error.response?.data || "An error occurred"
      );
    }
  }
);

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    addSignUpData: (
      state,
      action: PayloadAction<{
        firstName: string;
        lastName: string;
        mobileNumber: string;
        email: string;
      }>
    ) => {
      const { firstName, lastName, mobileNumber, email } = action.payload;
      state.userData.firstName = firstName;
      state.userData.lastName = lastName;
      state.userData.phone = mobileNumber;
      state.userData.email = email;
    },
    addBusinessUserData: (state: any, action: PayloadAction<any>) => {
      const { idNumber, ...formData } = action.payload;
      state.bussinessUserdata = {
        ...state.bussinessUserdata,
        ...formData,
      };
    },
    addUserData: (state: any, action: PayloadAction<any>) => {
      const { idNumber, ...formData } = action.payload;
      state.userData = {
        ...state.userData,
        ...formData,
        socialSecurityNumber: idNumber,
      };
    }, addKycError: (state: any, action: PayloadAction<any>) => {
      state.kycInvestorErrorState = action.payload;
    },
    setLoginInvestorId: (state: any, action: any) => {
      state.loginInvestorId = action.payload;
    },
    setLoginUserdetails: (state: any, action: any) => {
      if (action.payload === null) {
        state.loginUserDetails = initialState.loginUserDetails;
        state.loginInvestorId = initialState.loginInvestorId;
        state.businessInvestorAdminstration = initialState.businessInvestorAdminstration;
        state.businessInvestorControllingID = initialState.businessInvestorControllingID;
        state.businessInvestorBeneficialID = initialState.businessInvestorBeneficialID;
      } else {
        state.loginUserDetails = action.payload;
        state.loginInvestorId = action?.payload?.InvestorId || null;
        let beneficialIds: string[] = [];

        action?.payload?.BusinessAccounts?.map((ele: any) => {
          if (ele.BusinessUserType === "administrator") {
            state.businessInvestorAdminstration = ele.InvestorId;
          } else if (ele.BusinessUserType === "controlling_officer") {
            state.businessInvestorControllingID = ele.InvestorId;
          } else {
            beneficialIds.push(ele.InvestorId);
          }
        });
        state.businessInvestorBeneficialID = beneficialIds;
      }
    },
    setBenificial: (state: any, action: PayloadAction<number>) => {
      state.isBenificial = action.payload === 1 ? true : false;
    },
    setBenificialPercentage: (state: any, action: any) => {
      state.benificialPercentage = action.payload
    },
    setBenificialIds: (state: any, action: PayloadAction<string[]>) => {
      state.benificislaIds = action.payload;
    },
    addAdministration: (state: any, action: PayloadAction<OfficerData>) => {
      state.Administration = action.payload;
    },
    addcontrollingOfficer: (state: State, action: PayloadAction<{ data: OfficerData, isChecked: boolean }>) => {
      state.controllingOfficer = {
        ...action.payload.data,
        selectedExistingUser: action.payload.data.selectedExistingUser || state.controllingOfficer.selectedExistingUser
      };
      state.radioControllingState = action.payload.isChecked;
    },
    addSelectedExistingUser: (state: State, action: PayloadAction<string>) => {
      state.controllingOfficer.selectedExistingUser = action.payload;
    },
    addSelectedExistingBeneficialOwner: (state: State, action: PayloadAction<string>) => {
      state.benificialsOfficers[0].selectedExistingBeneficialOwner = action.payload;
    },
    addbenificialsOfficers: (
      state: any,
      action: PayloadAction<{
        data: OfficerData[], isThisBenificialOwnerCo: "yes" | "no",
        isThisBenificialOwner: "yes" | "no"
      }>
    ) => {
      state.benificialsOfficers = action.payload.data.map((officer, idx) => ({
        ...officer,
        selectedExistingBeneficialOwner: officer.selectedExistingBeneficialOwner || state.benificialsOfficers[idx]?.selectedExistingBeneficialOwner || ""
      }));
      state.isThisBenificialOwnerCoState = action.payload.isThisBenificialOwnerCo;
      state.isThisBenificialOwnerState = action.payload.isThisBenificialOwner;

    },
    addIsBenificialneededState: (state: State, action: PayloadAction<"yes" | "no">) => {
      state.isBenificialneededState = action.payload;
    },
    addIsThisBenificialOwnerCoState: (state: State, action: PayloadAction<"yes" | "no">) => {
      state.isThisBenificialOwnerCoState = action.payload;
    },
    addIsThisBenificialOwnerState: (state: State, action: PayloadAction<"yes" | "no">) => {
      state.isThisBenificialOwnerState = action.payload;
    },
    SetCheckEmail: (state: any, action: PayloadAction<any>) => {
      state.checkEmail = action.payload;
    },
    SetUserId: (state: any, action: any) => {
      state.loginUserId = action.payload;
    },
    resetAll: () => initialState,
    resetLoginDetails: (state) => {
      state.loginInvestorId = initialState.loginInvestorId;
    },
    businessUserEmpty: (state) => {
      state.bussinessUserdata = initialState.bussinessUserdata
    },
    addUpdateFlow: (state, action: PayloadAction<boolean>) => {
      state.isUpdateFlow = action.payload
    },
    addBussnissUpdateFlow: (state, action: PayloadAction<boolean>) => {
      state.isBusinessUpdate = action.payload
    },
    addBussnissRegUpdateFlow: (state, action: PayloadAction<boolean>) => {
      state.isBusinessRegUpdate = action.payload
    },
    initialResetState: (state) => {
      state.bussinessUserdata = initialState.bussinessUserdata;
      state.Administration = initialState.Administration;
      state.controllingOfficer = initialState.controllingOfficer;
      state.benificialsOfficers = initialState.benificialsOfficers;
      state.businessInvestorAdminstration = initialState.businessInvestorAdminstration;
      state.businessInvestorControllingID = initialState.businessInvestorControllingID;
      state.businessInvestorBeneficialID = initialState.businessInvestorBeneficialID;
      state.radioControllingState = initialState.radioControllingState;
      state.isBenificialneededState = initialState.isBenificialneededState;
      state.isThisBenificialOwnerCoState = initialState.isThisBenificialOwnerCoState;
      state.isThisBenificialOwnerState = initialState.isThisBenificialOwnerState;
      state.kycInvestorErrorState = initialState.kycInvestorErrorState
      state.isUpdateFlow = initialState.isUpdateFlow
      state.isBusinessUpdate = initialState.isBusinessUpdate
      state.isBusinessRegUpdate = initialState.isBusinessRegUpdate
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTermsUpdate.pending, (state) => {
        state.loading = true;
        state.error = "";
        state.tearmsIpdate = null;
      })
      .addCase(getTermsUpdate.fulfilled, (state, action) => {
        state.loading = true;
        state.tearmsIpdate = action.payload;
      })
      .addCase(getTermsUpdate.rejected, (state) => {
        state.loading = true;
        state.error = "";
        state.tearmsIpdate = null;
      })
      .addCase(postInvestorUser.pending, (state) => {
        state.loading = true;
        state.error = "";
        state.userResponse = null;
      })
      .addCase(postInvestorUser.fulfilled, (state, action) => {
        state.loading = true;
        state.userResponse = action.payload;
      })
      .addCase(postInvestorUser.rejected, (state) => {
        state.loading = true;
        state.error = "";
        state.userResponse = null;
      })
      .addCase(registerUser.pending, (state) => {
        state.loading = true;
        state.error = "";
        state.responseData = null;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        const { apiData, userData } = action.payload;
        state.loading = false;
        state.responseData = apiData;
        state.userData = userData;
        switch (action.payload.type) {
          case "admin":
            state.adminInvestorId = apiData.body.investorId;
            break;
          case "business":
            state.businessId = apiData.body.investorId;
            break;
          case "individual":
            state.investorId = apiData.body.investorId;
            break;
          case "Controlling":
            state.controllingId = apiData.body.investorId;
            break;
          case "Beneficial":
            state.beneficialId = apiData.body.investorId;
            break;
          default:
            break;
        }
      })
      .addCase(registerUser.rejected, (state, action: any) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to register user";
        state.responseData = action.payload?.body || {}; // Store error details in responseData
      })
      .addCase(editandDeleteProfile.pending, (state) => {
        state.loading = true;
        state.error = "";
        state.responseData = null;
      })
      .addCase(editandDeleteProfile.fulfilled, (state, action: any) => {
        const { apiData, userData } = action.payload;
        state.loading = false;
        state.responseData = apiData;
        state.userData = userData;
      })
      .addCase(editandDeleteProfile.rejected, (state, action: any) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to register user";
        state.responseData = action.payload?.body || {}; // Store error details in responseData
      })

      .addCase(getEmailStatus.pending, (state) => {
        state.loading = true;
        state.error = "";
        state.emailStatus = null;
      })
      .addCase(getEmailStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.emailStatus = action.payload;
      })
      .addCase(getEmailStatus.rejected, (state) => {
        state.loading = false;
        state.error = "";
        state.emailStatus = null;
      })


      .addCase(getRegisterdInvestors.pending, (state: State) => {
        state.loading = true;
        state.error = "";
        state.loginuserDetailsResponse = "";
        // state.investorId = null;
      })
      .addCase(getRegisterdInvestors.fulfilled, (state: State, action) => {
        const { response, investorId } = action.payload;
        state.loading = false;
        state.loginuserDetailsResponse = response;
        state.error = action.payload.error;
        if (!action.payload.response) {
          return;
        }
        state.userData = {
          purchaseProfile: response.PurchaseProfile,
          firstName: response.FirstName,
          lastName: response.LastName,
          socialSecurityNumber: "",
          birthDate: "",
          address: response.DeliveryLine,
          city: response.City,
          state: response.State,
          country: "US",
          IsExisting : response.IsExisting,
          userName: response.UserName,
          email: response.Email,
          phone: response.Phone,
          deliveryLine: response.DeliveryLine,
          zipCode: response.ZipCode,
          deliveryLine2: response.DeliveryLine2,
          userType: response.UserType,
          AccountStatus: response.AccountStatus,
          profileName: response.ProfileName,
          lastVerifiedOn: response.UpdatedAt,
          BusinessAccounts: response.BusinessAccounts,
          IsDefault: response.IsDefault,
          IsDeleted: response.IsDeleted,
          UserId: response.UserId,
          BusinessDetailsResponse: response.BusinessDetailsResponse,
        };
        state.investorId = investorId;
      })
      .addCase(getRegisterdInvestors.rejected, (state: State) => {
        state.loading = false;
        state.error = "";
        state.loginuserDetailsResponse = "";
      })
      .addCase(getInvestorProfile.pending, (state: State) => {
        state.loadingProfile = true;
        state.error = "";
      })
      .addCase(getInvestorProfile.fulfilled, (state: State, action) => {
        state.loadingProfile = false;
        state.userProfile = { ...action.payload?.body };
      })
      .addCase(getInvestorProfile.rejected, (state: State) => {
        state.loadingProfile = false;
        state.error = "";
      })
      .addCase(updateInvestorProfile.pending, (state: State) => {
        state.loadingUpdate = true;
        state.error = "";
      })
      .addCase(updateInvestorProfile.fulfilled, (state: State, action) => {
        state.loadingUpdate = false;
        // state.userProfile = { ...action.payload?.body }
      })
      .addCase(updateInvestorProfile.rejected, (state: State) => {
        state.loadingUpdate = false;
        // state.error = "";
      })
      .addCase(getExistingUser.pending, (state: State) => {
        state.loadingProfile = true;
        state.error = "";
      })
      .addCase(getExistingUser.fulfilled, (state: State, action) => {
        state.loadingProfile = false;
        state.responseData = action.payload ;
      })
      .addCase(getExistingUser.rejected, (state: State) => {
        state.loadingProfile = false;
        state.error = "";
      })
      ;
  },
});

export const {
  addSignUpData,
  addUserData,
  setBenificial,
  setBenificialIds,
  addBusinessUserData,
  addAdministration,
  addbenificialsOfficers,
  addcontrollingOfficer,
  addSelectedExistingUser,
  SetCheckEmail,
  initialResetState,
  resetAll,
  setLoginInvestorId,
  setLoginUserdetails,
  resetLoginDetails,
  SetUserId,
  businessUserEmpty,
  addIsBenificialneededState,
  addIsThisBenificialOwnerState,
  addIsThisBenificialOwnerCoState,
  addKycError,
  addUpdateFlow,
  addBussnissUpdateFlow,
  addBussnissRegUpdateFlow,
  setBenificialPercentage,
  addSelectedExistingBeneficialOwner
} = userSlice.actions;

export default userSlice.reducer;
